import { buffers, eventChannel } from 'redux-saga';
import { logger } from '../sagas/experiment';
import { gtag } from '../../utils/ga';

export const BUFFER_SIZE = 5;
export const experimentBuffer = buffers.sliding(BUFFER_SIZE);
export const readyBuffer = buffers.fixed(1);

export function createExperimentChannel() {
  // `eventChannel` takes a subscriber function
  // the subscriber function takes an `emit` argument to put messages onto the channel
  return eventChannel(experimentSubscriber, experimentBuffer);
}

export const experimentSubscriber = (emit) => {
  const optimizeCallback = (value, name) => {
    emit({ value, id: name });
    // puts event payload into the channel
    // this allows a Saga to take this payload from the returned channel
    logger.log(`Value: ${value}, Name: ${name}`);
  };

  // setup the subscription
  gtag('event', 'optimize.callback', { callback: optimizeCallback });

  logger.info(`optimize.callback initialized`);
  // the subscriber must return an unsubscribe function
  // this will be invoked when the saga calls `channel.close` method
  return () => {
    gtag('event', 'optimize.callback', {
      callback: optimizeCallback,
      remove: true,
    });
    logger.info('Callback destroyed');
  };
};

export function createReadyStateChannel() {
  return eventChannel(readyStateSubscriber, readyBuffer);
}

export const readyStateSubscriber = (emitter) => {
  const initialValue = window.optimizeReadyCallback;

  window.optimizeReadyCallback = () => {
    emitter(true);
  };

  return () => {
    window.optimizeReadyCallback = initialValue;
  };
};
